// extracted by mini-css-extract-plugin
export default {"container":"TopicDetailsPage_container__m7RBb"};